import React from 'react';
import { type ReactNode } from 'react';
import { Divider, Stack } from '@packages/shared';

export const ActionBar = ({ children }: { children: ReactNode[] }) => (
  <>
    <Divider />
    <Stack direction="row" justifyContent="flex-end">
      {children?.map(
        (child, index) =>
          child && (
            <React.Fragment
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            >
              {index !== 0 && (
                <Divider orientation="vertical" variant="middle" flexItem data-testid="divider" />
              )}
              {child}
            </React.Fragment>
          ),
      )}
    </Stack>
  </>
);
